import React, { useEffect } from "react";
import { config, isProduction, isDevelopment } from "../config";
export const ProjectThemeProvider = ({ children }) => {
    useEffect(() => {
        // Apply CSS variables for dynamic theming
        const root = document.documentElement;
        root.style.setProperty("--primary-color", config.theme.primaryColor);
        root.style.setProperty("--secondary-color", config.theme.secondaryColor);
        root.style.setProperty("--project-name", config.project);
        // Add project-specific class to body
        document.body.classList.add(`project-${config.project}`);
        document.body.classList.add(`env-${config.env}`);
        // Update document title
        const projectName = config.project.charAt(0).toUpperCase() + config.project.slice(1);
        document.title = `${projectName}`;
        // Update favicon dynamically
        const updateFavicon = () => {
            let faviconLink = document.querySelector("link[rel*='icon']");
            if (!faviconLink) {
                faviconLink = document.createElement("link");
                faviconLink.rel = "icon";
                document.head.appendChild(faviconLink);
            }
            faviconLink.href = config.theme.favicon;
        };
        updateFavicon();
        // Load Razorpay script with project-specific key
        if (!document.querySelector("#razorpay-script")) {
            const script = document.createElement("script");
            script.id = "razorpay-script";
            script.src = "https://checkout.razorpay.com/v1/checkout.js";
            script.async = true;
            document.head.appendChild(script);
        }
        // Load Clarity analytics for production
        if (isProduction() && config.analytics.clarityProjectId && !document.querySelector("#clarity-script")) {
            const clarityScript = document.createElement("script");
            clarityScript.id = "clarity-script";
            clarityScript.innerHTML = `
        (function(c,l,a,r,i,t,y){
          c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
          t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
          y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "${config.analytics.clarityProjectId}");
      `;
            document.head.appendChild(clarityScript);
        }
        // Add environment badge for development
        if (isDevelopment()) {
            const badge = document.createElement("div");
            badge.id = "env-badge";
            badge.style.cssText = `
        position: fixed;
        bottom: 10px;
        right: 10px;
        background: rgba(0,0,0,0.8);
        color: ${config.theme.primaryColor};
        padding: 4px 12px;
        border-radius: 20px;
        font-size: 11px;
        font-family: monospace;
        z-index: 9999;
        pointer-events: none;
        font-weight: bold;
        backdrop-filter: blur(5px);
      `;
            badge.textContent = `${config.project.toUpperCase()} | ${config.env}`;
            document.body.appendChild(badge);
            return () => {
                if (badge && document.body.contains(badge)) {
                    document.body.removeChild(badge);
                }
            };
        }
        return () => {
            document.body.classList.remove(`project-${config.project}`);
            document.body.classList.remove(`env-${config.env}`);
        };
    }, []);
    return React.createElement(React.Fragment, null, children);
};
